import template from './what_todo_next.html';
import * as Navbar from '../../lib/update_navbar_notifications.js';
import tr from '../../lib/default-translator.js';

class WhatTodoNextViewModel
{
	constructor (page)
	{
		this.page = page;

		this.task_amount = ko.observable(10);
		this.task_done_count = ko.observable(0);
		this.employee_create = ko.observable(false);
		this.field_create = ko.observable(false);
		this.holiday_create = ko.observable(false);
		this.leave_create = ko.observable(false);
		this.branch_create = ko.observable(false);
		this.leave_attach = ko.observable(false);
		this.feature_roles = ko.observable(false);
	};

	async mark_complete(v, e)
	{
		let system_name = e.currentTarget.value;

		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want mark this as done? ')});
		if (response)
		{
			let result = await Grape.fetches.postJSON('/api/save_setting/', { name: system_name, value: true });
			if (result.status == 'ERROR')
				Grape.alerts.apiError(result);
			else
				location.reload(); 
		}
		else
			location.reload(); 
	};
};

class WhatTodoNextPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new WhatTodoNextViewModel(this);
	}

	init()
	{
		document.title = tr('What To Do Next');
		window.current_page_title(' ');
	}

	updateData()
	{
		this.updateDoneList();
	}

	async updateDoneList()
	{
		this.viewModel.task_amount(0);
		this.viewModel.task_done_count(0);
		
		let self = this;

		$('.next-step-card').each(async function(index) {
			let setting_name = $(this).attr('setting-name');
			let reference = $(this);

			self.viewModel.task_amount(self.viewModel.task_amount() + 1);

			let res = await Grape.fetches.getJSON('/api/setting/' + setting_name, {});

			if (res.value === true || res.value === 'true')
			{
				reference.addClass('completed');
				self.viewModel.task_done_count(self.viewModel.task_done_count() + 1);
				switch (setting_name) {
					case 'system.wizard_create_employee_done':
						self.viewModel.employee_create(true);
						break;
					case 'system.wizard_create_employee_field_done':
						self.viewModel.field_create(true);
						break;
					case 'system.wizard_insert_holiday_done':
						self.viewModel.holiday_create(true);
						break;
					case 'system.wizard_create_leave_type_done':
						self.viewModel.leave_create(true);
						break;
					case 'system.wizard_insert_branch_done':
						self.viewModel.branch_create(true);
						break;
					case 'system.wizard_attach_leave_type_to_employee_done':
						self.viewModel.leave_attach(true);
						break;
					case 'system.wizard_customize_roles_and_features_done':
						self.viewModel.feature_roles(true);
						break;
					default:
						break;
				}

				// set global done when all tasks are done
				if (self.viewModel.task_done_count() == self.viewModel.task_amount())
				{
					try {
						Grape.fetches.patchJSON = (url, data, callback) => {
							$.ajax({
								url: url,
								type: 'PATCH',
								contentType: 'application/json',
								data: JSON.stringify(data),
								success: callback,
								error: () => { },
							})
						}
		
						let res = await Grape.fetches.patchJSON('/api/setting/' + 'system.wizard_all_tasks_done', { name: 'system.wizard_all_tasks_done', value: 'true' });
						if (res.status == 'ERROR')
							Grape.alerts.apiError(res);
					}
					catch (err) {
					}
				}
			}
			else
				reference.removeClass('completed');
		});

		await Navbar.updateWizardNotDoneCount(); 
	}
}

export default {
	route: '[/]wizard/what_todo_next',
	page_class: WhatTodoNextPage,
	template: template,
	template_filename: 'translation/what_todo_next'
};
